import { useState } from 'react'
import { Link } from 'react-router-dom'

import { ROUTES } from '../../../routes/types'
import { Icon } from '../../atoms'

interface LicenseExpirationBannerProps {
  expirationDate?: Date | string
  daysUntilExpiration?: number
}

export function LicenseExpirationBanner({ expirationDate, daysUntilExpiration }: LicenseExpirationBannerProps) {
  const [isDismissed, setIsDismissed] = useState(false)

  // Calculate days until expiration if not provided
  let days = daysUntilExpiration

  if (days === undefined && expirationDate) {
    const expDate = typeof expirationDate === 'string' ? new Date(expirationDate) : expirationDate
    const now = new Date()
    days = Math.ceil((expDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
  }

  // Don't show if dismissed or more than 30 days until expiration
  if (isDismissed || days === undefined || days > 30) {
    return null
  }

  // Determine urgency level
  const isExpired = days <= 0
  const isUrgent = days <= 7
  const isWarning = days <= 30

  const bgColor = isExpired ? 'bg-red-600' : isUrgent ? 'bg-orange-500' : 'bg-yellow-500'

  const message = isExpired
    ? 'Your license has expired. Some features may be unavailable.'
    : days === 1
      ? 'Your license expires tomorrow.'
      : `Your license expires in ${days} days.`

  return (
    <div className={`${bgColor} px-4 py-2`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-white">
          <Icon name={isExpired || isUrgent ? 'alert' : 'warning'} size="sm" />
          <span className="text-sm font-medium">{message}</span>
          <Link to={ROUTES.SETTINGS_LICENSE} className="ml-2 text-sm underline hover:no-underline">
            Renew now
          </Link>
        </div>
        {isWarning && !isExpired && (
          <button
            onClick={() => setIsDismissed(true)}
            className="rounded p-1 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
            aria-label="Dismiss"
          >
            <Icon name="close" size="sm" />
          </button>
        )}
      </div>
    </div>
  )
}
